import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";

import { HashRouter as Router, Routes, Route } from "react-router-dom";

import Contacts from "./pages/Contacts";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import Skills from "./pages/Skills";
import NotFound from "./pages/Notfound";


import ScrollToTop from "./components/utils/scrollTotop";

import './styles/main.css';

function App() {
  return (
    <>

    <Router>
      <ScrollToTop />
      <Header />
      <div className="body">
        <Routes>
          <Route path="/" element ={<Home />} />
          <Route path="/skills" element ={<Skills />} />
          <Route path="/projects" element ={<Projects />} />
          <Route path="/project/:name" element ={<Project />} />
          <Route path="/contacts" element ={<Contacts />} />
          <Route path="*" element={<NotFound/>}  />
        </Routes>
        </div>

      <Footer />
      
    </Router>
 
    </>
  );
}

export default App;
